/** MI DOMINO - online protocol core: seat geometry, legal-ends against the
 *  server snapshot, and sending a play. Pure w.r.t. the DOM. */
import { NET, socket } from '../state';

/** Seat position relative to me: 0=me, 1=right, 2=partner, 3=left. */
export const REL = (seat: number): number => (seat - (NET.mySeat ?? 0) + 4) % 4;

export const VID_BY_REL: Record<number, string> = { 0: 'vid0', 1: 'vid1', 2: 'vid2', 3: 'vid3' };
export const NAME_BY_REL: Record<number, string> = { 0: 'name0', 1: 'name1', 2: 'name2', 3: 'name3' };
export const BACKS_BY_REL: Record<number, string> = { 1: 'backs1', 2: 'backs2', 3: 'backs3' };
export const SEAT_EL_BY_REL: Record<number, string> = { 0: 'me-info', 1: 'seat-right', 2: 'seat-top', 3: 'seat-left' };

/** Which ends a tile may play on, per the current online snapshot. */
export function netSides(tile: number[]): string[] {
  const s = NET.snap;
  if (!s) return [];
  if (s.board.length === 0) {
    return s.mustPlayDouble6 ? (tile[0] === 6 && tile[1] === 6 ? ['first'] : []) : ['first'];
  }
  const r = [];
  if (tile[0] === s.leftEnd || tile[1] === s.leftEnd) r.push('left');
  if (tile[0] === s.rightEnd || tile[1] === s.rightEnd) r.push('right');
  return r;
}

/** Emit a play to the server. */
export function sendPlay(tile: number[], side: string): void {
  if (socket) socket.emit('play', { tile, side });
}
